import { Box, Button } from "@material-ui/core";
import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
export default function StepButtonsX(props) {
   
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "60%",
        margin: "25px auto",
      }}
    >
      <Button
        variant="outlined"
        onClick={props.handleBack}
        disabled={props.activeStep === 0}
      >
        <ArrowForwardIosIcon style={{ marginRight: 5, fontSize: "1em" }} />
        <span>مرحله قبل</span>
      </Button>
      {!props.showCreateGroup ? (
        ""
      ) : (
        <Button
          variant="contained"
          onClick={() => props.createGroupHandler(null, false)}
          disabled={props.activeStep === 0}
          style={{
            background: "rgb(60, 232, 183)",
          }}
        >
          ایجاد گروه
        </Button>
      )}
      <Button
        variant="contained"
        style={{
          background: "#65e3f0",
        }}
        onClick={props.handleNext}
        disabled={
          props.disableNext 
        }
      >
        {props?.activeStep !== 6 ? (
          <>
            <span>مرحله بعد</span>
            <ArrowBackIosIcon style={{ marginRight: 5, fontSize: "1em" }} />
          </>
        ) : (
          <>
            <span style={{fontWeight:'800'}}>ثبت نهایی</span>
            <CheckCircleOutlineIcon style={{ marginRight: 5, fontSize: "1.3em" }}/>
          </>
        )}
      </Button>
    </Box>
  );
}
